import request from '@/utils/request'
import { v2Host } from '@/config/host'
import { AxiosPromise } from 'axios'

export function readBin(params: { url: string }, withoutError: number): AxiosPromise {
  return request({
    url: v2Host + '/common/bin/read',
    method: 'get',
    params,
    withoutError
  })
}
